module.exports = __webpack_public_path__ + "static/live-room-4-bf005280447a0673632abae56205f22b.jpg";